<div class="container mb-5 marginMobile">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-12 col-md-8 col-lg-8 col-xl-10">
            <div class="card p-3">
              <script>

              </script>
              <!-- <button class="btn btn-primary" (click)="openPDF()" type="button" name="button" style="width:100%;"><i class="fa fa-file-pdf-o"></i> Generate PDF</button> -->
              <div class="row">
                <div class="col-md-12">
                  <input type="text" id="myInput" onkeyup="myFunction()" placeholder="Recherche.." title="Type in a name">
                </div>
              </div>
              <div class="table-responsive">
                <table id="tableBalance" class="table table-striped" style="width:100%">
                  <thead>
                      <tr>
                          <th>Num facture</th>
                          <th>Date facture</th>
                          <!-- <th>Adresse 1</th>
                          <th>Adresse 2</th>
                          <th>Adresse 3</th> -->
                          <th>Montant TTC</th>
                          <th>Montant HT</th>
                          <!-- <th>Actions</th> -->
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let facture of factures">
                          <td><a [routerLink]="['/facture', facture.NUM]">{{facture.NUM}}</a></td>
                          <td>{{facture.ACCDAT | dateform}}</td>
                          <!-- <td>{{facture.BPAADDLIG0}}</td>
                          <td>{{facture.BPAADDLIG1}}</td>
                          <td>{{facture.BPAADDLIG2}}</td> -->
                          <td>{{facture.AMTATI}}</td>
                          <td>{{facture.AMTNOT}}</td>
                          <!-- <td>
                            <a [routerLink]="['/facture', facture.NUM]">
                            <button class="btn detailFacture" type="button" name="button" style="width:100%; margin-bottom:2px;"><i class="fa fa-eye"></i> Détail</button>
                            </a>
                          </td> -->
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
